import Storage from './Storage'
import RoleUtil from "./RoleUtil";

const User = {

  isAdvisor() {
    return this.isDuiServiceAdvisor() || this.isDuiAdmin();
  },

  isCallCenterAgent() {
    const user = Storage.getItem('user');
    return RoleUtil.CALL_CENTER_AGENT === user.role;
  },

  isDuiAdmin() {
    const user = Storage.getItem('user');
    return RoleUtil.DUI_ADMIN === user.role;
  },

  isDuiServiceAdvisor() {
    const user = Storage.getItem('user');
    return RoleUtil.DUI_SERVICE_ADVISOR === user.role;
  },

  isNscAdmin() {
    const user = Storage.getItem('user');
    return RoleUtil.NSC_ADMIN === user.role;
  }
};

export default User;



// WEBPACK FOOTER //
// ./src/services/User.js